import './TopNavigation.css';
import React, { useEffect, useState } from 'react';
import HeaderModuleWrapper from '../30_NavigationBar/HeaderModuleWrapper';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, getGlobalDictionaryTerm } from '../../utils';
import { tealiumClickFunc } from '../../utils/tealium';
import { getUserCookie, getLatestUserCookie } from '../Login/user_session';
import { getEmptyTopPicksStorage, syncTopPicks, getTopPicks, setTopPicksStorage, getTopPicksStorage } from '../atoms/FavouriteBtn/top_picks_apis';
import { get } from '../../utils';

/** Defines the props that are populated by data from CMS */

/** Defines the props that are populated by data from CMS and application usage */

const TopLinks = _ref => {
  let {
    items,
    analytics
  } = _ref;
  const [itemMaped, setItemMaped] = useState([]);
  const sitecoreContext = useSitecoreContext();
  const currentLang = String(sitecoreContext && sitecoreContext.language);
  const siteName = get(sitecoreContext, 'site.name') || '';
  useEffect(() => {
    items.forEach((item, index) => {
      item.active = isActive(item, index);
    });
    setItemMaped(items);
  }, [items]);
  const isActive = (item, index) => {
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
      let url = window.location.pathname.replace(`${currentLang}`, '').split('/').filter(item => item.length).join('/');
      const body = document.querySelector('body');
      const isVDsite = body && body.classList.contains('vdsite');

      //check if corporate item active
      const isCorporateItemActive = itemSiteName => !isVDsite && itemSiteName === 'dotsite';
      let {
        url: itemLink
      } = item.link;
      itemLink = itemLink ? itemLink.replace(`/${currentLang}/`, '').split('/').join('/') : itemLink;
      const itemSiteName = item.siteName ? item.siteName.value : '';
      const leisureTempateSites = ['study-dubai', 'mice', 'retire-in-dubai'];
      const isItemActive = () => {
        if (itemSiteName && itemSiteName === 'leisure') {
          return url.length === 0 ? itemSiteName.includes(siteName) : itemSiteName.includes(siteName) && !leisureTempateSites.some(sub => url.includes(sub));
        } else if (itemSiteName) {
          return itemSiteName.includes(siteName);
        } else {
          return url.length !== 0 && url.includes(itemLink);
        }
      };
      return isVDsite ? isItemActive() : isCorporateItemActive(itemSiteName);
    } else {
      return false;
    }
  };
  return itemMaped.length ? itemMaped.map((globalLink, index) => {
    let target = globalLink.link.target;
    const rel = target && target === '_blank' ? 'noopener noreferrer' : undefined;
    let title = globalLink.label.value;
    if (target === '_blank') {
      const newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || 'Opens in a new window';
      title = `${title} | ${newWindowLabel}`;
    }
    if (target === '') {
      target = '_self';
    }
    if (!title) {
      return null;
    }
    return /*#__PURE__*/React.createElement("a", {
      className: `top-nav__link ${globalLink.active ? 'top-nav__link--active' : ''}`,
      "data-active": `${globalLink.active}`,
      href: get(globalLink, 'link.url'),
      target: target,
      rel: rel,
      onClick: () => {
        tealiumClickFunc(analytics.globalLinksAnalytics, `${globalLink.name}`);
      },
      key: `top-nav-link${index}`,
      title: title
    }, globalLink.label.value);
  }) : /*#__PURE__*/React.createElement("div", null);
};
const TopNavigation = _ref2 => {
  let {
    globalLinks,
    activeLanguageName,
    languageSelectorTitle,
    accessibilitySettingsTitle,
    actions,
    dictionary,
    accountLinks,
    analytics
  } = _ref2;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  const clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  const apiGlobal = get(sitecoreContext, 'configuration.globalApi.apiGlobal') || 'https://replaceapiGlobal';
  const clientSecret = get(sitecoreContext, 'configuration.globalApi.clientSecret') || 'replacesecret';
  const addTopPicksClass = () => {
    const topPicks = getTopPicksStorage();
    if (topPicks && topPicks.list && topPicks.list.length) {
      if (canUseDOM) {
        document.body.classList.add('has--favourites');
      }
    }
  };
  React.useEffect(() => {
    if (getUserCookie().login_status) {
      getLatestUserCookie(identityGlobal, clientId, clientSecret).then(userCookie => {
        if (userCookie.login_status) {
          if (!userCookie.error) {
            let topPicks = getTopPicksStorage();
            if (topPicks.sync) {
              getTopPicks(userCookie.access_token, apiGlobal).then(topPicks => {
                if (!topPicks.failed) {
                  let obj = getTopPicksStorage();
                  obj.list = topPicks || [];
                  setTopPicksStorage(obj);
                  addTopPicksClass();
                } else {
                  addTopPicksClass();
                }
              });
            } else {
              syncTopPicks(userCookie.access_token, apiGlobal).then(result => {
                if (result) {
                  getTopPicks(userCookie.access_token, apiGlobal).then(topPicks => {
                    if (!topPicks.failed) {
                      setTopPicksStorage(getEmptyTopPicksStorage(topPicks));
                    } else {
                      addTopPicksClass();
                    }
                  });
                } else {
                  addTopPicksClass();
                }
              });
            }
          } else {
            addTopPicksClass();
          }
        } else {
          addTopPicksClass();
        }
      });
    } else {
      addTopPicksClass();
    }
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "top-nav"
  }, globalLinks.targetItem && globalLinks.targetItem.children && /*#__PURE__*/React.createElement(TopLinks, {
    analytics: analytics,
    items: globalLinks.targetItem.children
  })))));
};
export default TopNavigation;
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    className
  } = _ref3;
  return /*#__PURE__*/React.createElement(HeaderModuleWrapper, {
    className: `top-navigation-component ${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`
  }, children);
};
const commonStyles = "c1p618zp";
const ltrStyles = "ln7p0i3";
const rtlStyles = "r67msif";